module.exports = __webpack_public_path__ + "static/media/location-maps-letter-l-arrow.077d66af.png";